export class OpportunityFilter {
    searchValue: string;
    lastMonth = 1;
}
